import { Link } from 'react-router-dom';
import { knowledgeIntro, knowledgeGroups, knowledgeTopics } from '@/mocks/knowledgeCatalogue';

const topicIcons: Record<string, string> = {
  'tnt-about': 'ri-information-line',
  'tnt-coaching': 'ri-user-voice-line',
  'tnt-features': 'ri-apps-2-line',
  'tnt-goals': 'ri-flag-line',
  'tnt-access': 'ri-wallet-3-line',
  'tnt-safety': 'ri-shield-check-line',
};

const totalQuestions = knowledgeGroups.reduce(
  (sum, group) => sum + group.faqs.length,
  0
);

export default function KnowledgeCatalogueSection() {
  return (
    <section
      id="tnt-knowledge-hub"
      aria-labelledby="tnt-kb-title"
      className="relative scroll-mt-20 py-16 md:py-20 bg-midnight border-t border-royal-navy/30"
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <header className="max-w-3xl mb-10">
            <p className="text-champagne-gold uppercase tracking-[0.18em] text-xs font-semibold mb-3">
              {knowledgeIntro.eyebrow}
            </p>
            <h2
              id="tnt-kb-title"
              className="text-2xl md:text-4xl text-warm-white leading-tight mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Everything you might want to know, answered
            </h2>
            <p className="text-silver-grey leading-relaxed">
              {totalQuestions} questions about TNT Coach AI — what it does, the coaching styles,
              features, goals and habits, pricing, and where its limits are.
            </p>
          </header>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {knowledgeTopics.map((topic) => {
              const group = knowledgeGroups.find((item) => item.id === topic.id);
              const count = group ? group.faqs.length : 0;
              return (
                <Link
                  key={topic.id}
                  to={`/knowledge#${topic.id}`}
                  className="group flex items-start gap-3 rounded-lg border border-royal-navy/40 bg-royal-navy/10 px-4 py-4 hover:border-champagne-gold/50 hover:bg-royal-navy/20 transition-colors duration-300 cursor-pointer"
                >
                  <span className="w-9 h-9 rounded-md bg-champagne-gold/10 border border-champagne-gold/20 flex items-center justify-center shrink-0">
                    <i
                      className={`${topicIcons[topic.id] || 'ri-question-line'} text-champagne-gold text-base`}
                    />
                  </span>
                  <span className="min-w-0">
                    <span className="block text-warm-white font-medium text-sm leading-snug group-hover:text-champagne-gold transition-colors duration-300">
                      {topic.label}
                    </span>
                    <span className="block text-taupe-grey text-xs mt-1">
                      {count} {count === 1 ? 'question' : 'questions'}
                    </span>
                  </span>
                </Link>
              );
            })}
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/knowledge"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full gold-gradient text-midnight font-semibold text-sm hover:opacity-90 transition-opacity duration-300 whitespace-nowrap cursor-pointer"
            >
              Read all {totalQuestions} answers
              <i className="ri-arrow-right-line" />
            </Link>
            <p className="text-taupe-grey text-sm">
              Full knowledge hub with every question expanded in detail.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}